













































































































import Vue from 'vue'
import { mapGetters } from 'vuex'
import Media from '@/types/Media.interface'
import User from '@/types/User.interface'
import mixin from '@/mixins/message-mixin'
import { popPreview } from '@/utility/helpers'
import UserLogo from '@/components/UserLogo.vue'
import Button from '@/types/components/Button.interface'
import SlidingAlert from '@/components/SlidingAlert.vue'
export default Vue.extend({
    mixins: [mixin],
    components: { SlidingAlert, UserLogo },
    props: {
        fullWidth: {
            type: Boolean,
            default: false,
            required: false
        },
        message: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        loading: false,
        hovering: false
    }),
    computed: {
        ...mapGetters(['getErrorMessage', 'isApp', 'persons', 'users']),
        caratStyle(): object {
            return {
                position: 'absolute',
                top: '-10px',
                right: '15px',
                filter: 'drop-shadow(0 -2.5px 0 rgba(0, 0, 0, 0.25))',
                'border-color': `transparent transparent ${this.messageBubbleColor} transparent`,
                'border-style': 'solid',
                'border-width': '0 12px 12px 12px'
            }
        },
        containerId(): string {
            //  Grab our message id
            const id = this.message.id

            //  Construct a compound id
            return `message-outbound-${id}`
        },
        displayAvatar(): boolean {
            //  Grab our message user
            const user = this.messageUser

            //  If we don't have a message user, return false
            if (!user) return false

            //  Grab our message type
            const type = this.message.type

            //  If our type doesn't exist, return true
            if (!type) return true

            //  Else, return based on if this is send
            return type === 'send'
        },
        hoverButtons(): Button[] {
            //  Create our array of buttons
            return [
                {
                    icon: 'bi-quote',
                    color: 'white',
                    tooltip: 'Comment',
                    callback: () => this.$emit('comment')
                },
                {
                    icon: 'bi-front',
                    color: 'white',
                    tooltip: 'Copy to Clipboard',
                    hidden: !this.message.text,
                    callback: () => this.copyMessage()
                },
                {
                    icon: 'bi-trash-fill',
                    color: 'white',
                    tooltip: 'Delete Message',
                    disabledPopup: this.operator,
                    callback: () => this.deleteMessageConfirm()
                }
                // {
                //     icon: 'bi-circle-fill',
                //     color: 'primary',
                //     callback: () => console.log('MARK AS NEW')
                // },
                // {
                //     icon: 'bi-translate',
                //     color: 'white',
                //     callback: () => console.log('TRANSLATE')
                // }
            ]
        },
        hoverStyle(): object {
            return {
                display: 'flex',
                'align-items': 'center',
                'justify-content': 'center',
                position: 'absolute',
                top: '-40px',
                right: 0,
                height: '40px',
                width: '220px',
                'border-radius': '10px',
                filter: 'drop-shadow(0 2px 2px #000)',
                'background-color': this.messageBubbleColor,
                'z-index': 1
            }
        },
        iconBubbleColor(): string {
            //  If this is a comment, our typing will be comment.type or default to itself
            const type = this.message.type

            //  Grab our color based on this type
            const color =
                {
                    autoresponder: '#4D4D4D',
                    broadcast: '#4D4D4D',
                    form: '#4D4D4D',
                    invoice: this.$colors.mdPurple70,
                    'office hours': '#4D4D4D',
                    chatbot: '#4D4D4D',
                    compliance: 'null',
                    consent: '#4D4D4D',
                    send: this.$colors.mdPurple70
                }[type] || this.$colors.mdPurple70

            //  Return our color
            return color
        },
        isFailed(): boolean {
            //  The message has failed if delivery does NOT exist, AND, the status is 'failed'
            const isFailed = !this.message.delivered && this.message.status === 'failed'

            return isFailed
        },
        messageBubbleColor(): string {
            //  If this is a comment, our typing will be comment.type or default to itself
            const type = this.message.type

            //  Grab our color based on this type
            const color =
                {
                    autoresponder: '#4D4D4D',
                    broadcast: '#4D4D4D',
                    form: '#4D4D4D',
                    invoice: this.$colors.mdPurple70,
                    'office hours': '#4D4D4D',
                    chatbot: '#4D4D4D',
                    compliance: this.$colors.mdPurple70,
                    consent: '#4D4D4D',
                    send: this.$colors.mdPurple70
                }[type] || this.$colors.mdPurple70

            //  Return our color
            return color
        },
        messageIcon(): string {
            //  If this is a comment, our typing will be comment.type or default to itself
            const type = this.message.type

            //  Icon depends on type of message
            const icon =
                {
                    autoresponder: 'bi-lightning-fill',
                    broadcast: 'mdi-bullhorn',
                    form: 'mdi-form-select',
                    invoice: 'bi-cash',
                    'office hours': 'mdi-clock',
                    chatbot: 'bi-chat-square-fill',
                    compliance: '$images.brandMark',
                    consent: 'mdi-message-lock'
                }[type] || 'mdi-account'

            //  Return our icon
            return icon
        },
        messageTooltip(): string {
            //  If this is a comment, our typing will be comment.type or default to itself
            const type = this.message.type

            //  Get our tooltip
            const tooltip =
                {
                    autoresponder: 'Autoresponder',
                    broadcast: 'Broadcast',
                    form: 'Form',
                    invoice: 'Invoice',
                    'office hours': 'Office Hours',
                    chatbot: 'Chatbot',
                    compliance: 'Compliance',
                    consent: 'Consent'
                }[type] || this.messageUser?.firstname

            //  Return the tooltip
            return tooltip
        },
        messageUser(): User | null {
            //  If the message does NOT have an author_id, return null (this occurs when the message was created by the system, rather than user)
            if (!this.message.author_id) return null

            //  Get the message's author/person (persons related to Users are loaded in initial state requests in AppSync::onTenantSet)
            const author = this.persons.find((x) => x.id === this.message.author_id)

            //  If the author does NOT exist, return null (this can occur in a race condition when initial state is still loading)
            if (!author) return null

            //  Get the user
            const user = this.users.find((x) => x.id === author.user_id)

            //  Return the user bound to the message author
            return user
        },
        operator(): boolean {
            //  Grab our current role
            const role = this.$store.getters.userRole(this.$store.getters.user)

            //  Check if this role is an operator
            return window.getProps(role, ['name']) === 'Operator'
        },
        parsedMessageText(): string {
            //  If message text does NOT exist, return nothing
            if (!this.message.text) return null

            //  Else, return parsed message
            const txt = this.$options.filters.parseMessageText(this.message.text, true)

            //  Return text
            return txt
        },
        validRoute(): boolean {
            //  Only return true if our path contains inbox OR teammates
            return (
                this.$route.path.includes('inbox') ||
                this.$route.path.includes('teammates')
            )
        }
    },
    methods: {
        btnCallback(btn: Button): void {
            //  Trigger button callback
            btn.callback()
        },
        async cancelSchedule(): Promise<void> {
            //  Start the loading spinner
            this.loading = true

            //  Send the cancel request to the API
            const response = await this.$store.dispatch('messagesDelete', this.message)

            //  Stop the loading spinner
            this.loading = false

            //  If the request failed, no nothing
            if (!response) return

            //  Else, notify user of success
            this.$store.commit('appNotificationBarSet', {
                message: 'Scheduled message canceled successfully',
                type: 'success'
            })
        },
        copyMessage(): void {
            //  Create a temporary input to store our data
            const input = document.createElement('textarea')

            //  Add our input to the DOM
            document.body.appendChild(input)

            //  Get our parsed text
            const text = this.$options.filters.parseCommentedText(
                this.message.text,
                false
            )

            //  Set the value of this input to our message text
            input.value = text

            //  Focus our input
            input.focus()

            //  Select the text in our input (message text)
            input.select()

            //  Copy the text to clipboard
            document.execCommand('Copy')

            //  Remove our input now that we copied text
            input.remove()

            //  Notify our user with toast :)
            this.$store.commit('appNotificationBarSet', {
                message: 'Message Text Copied to Clipboard!',
                type: 'success'
            })
        },
        deleteMessageConfirm(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'CONFIRM',
                title: 'Delete Message',
                text: `Are you sure you'd like to delete this message? If yes, it will be removed from the conversation history`,
                icon: 'mdi-alert',
                color: 'primary',
                callback: (result: boolean) => this.deleteMessage(result)
            })
        },
        async deleteMessage(result: boolean): Promise<void> {
            //  If no result, do nothing
            if (!result) return

            // Else, delete the failed message
            const resp = await this.$store.dispatch('messagesDelete', this.message)
        },
        iconClick(): void {
            //  If the message type is compliance, do nothing
            if (this.message.type == 'compliance') return

            //  Grab the user id from the message
            const user_id = this.messageUser?.id

            //  Route depends on type of message
            const route =
                {
                    autoresponder: '/auto-responders',
                    broadcast: '/broadcasts',
                    consent: '/opt',
                    form: '/forms',
                    'office hours': 'office-hours',
                    invoice: '/invoices'
                }[this.message.type] || `/teammates?user=${user_id}`

            //  Push to that route
            this.$router.push(route)
        },
        messageReceipt(): string {
            //  If no delivered or updated date, don't display a receipt
            if (!this.message.delivered && !this.message.updated_at) return null

            //  We don't want to use created_at for scheduled messages even if they're 9902's as the timestamp could be off by days or even months 
            const isCarrierError = this.message.provider_err === '9902' && this.message.type !== "scheduled"

            //  Due to 9902 errors having a two hour delay added to message.updated_at we instead use created_at for these messages 
            //  to more give customers a better timestamp. Date will be created_at if a 9902, otherwise it'll be updated_at or delivered if it was delivered
            const date =  isCarrierError 
                ? this.$options.filters.chatDate(this.message.created_at) 
                : this.$options.filters.chatDate(this.message.delivered || this.message.updated_at)
           
            //  Our status is either our message status in proper case, or 'Sent'
            let status = this.message.status ? this.message.status.toProperCase() : 'Sent'

            //  If the status is Failed, we need to get the reason why
            if (status === 'Failed') {
                const err = this.getErrorMessage(this.message)
                status = err.reason
            }

            //  Create our report
            return `${status} ${date}`
        },
        popPreview(media: Media): void {
            popPreview(media)
        }
    }
})
